export default __webpack_public_path__ + "static/media/copy-synced-icon.86037622.svg";